import React from 'react'
import { Box, Text } from '@workwhile/ui'
import { formatInTimeZone } from 'date-fns-tz'

export type TimeConversionZone = {
  timeZone: string
  context?: string
}

type TimeConversionContentProps = {
  value: string | Date
  zones: TimeConversionZone[]
}

const cellStyle = { whiteSpace: 'nowrap' as const }

export const TimeConversionContent = ({
  value,
  zones,
}: TimeConversionContentProps) => {
  const date = typeof value === 'string' ? new Date(value) : value

  return (
    <Box>
      <Box pb={1} borderBottom="1px solid" borderColor="neutrals.100">
        <Text fontWeight="bold" fontSize={1}>
          Time conversion
        </Text>
      </Box>
      <Box
        display="grid"
        gridTemplateColumns="minmax(0, 1fr) auto auto"
        style={{ columnGap: 32 }}
      >
        {zones.map(({ timeZone, context }, index) => (
          <React.Fragment key={`${timeZone}-${context ?? ''}-${index}`}>
            {index > 0 ? (
              <Box
                gridColumn="1 / -1"
                borderTop="1px solid"
                borderColor="neutrals.100"
                style={{ height: 0, lineHeight: 0 }}
              />
            ) : null}
            <Box py={2}>
              <Text fontSize={2} style={cellStyle}>
                <Text as="span" fontWeight="bold">
                  {formatInTimeZone(date, timeZone, 'zzz')}
                </Text>
                {context ? ` • ${context}` : null}
              </Text>
            </Box>
            <Box py={2} alignSelf="center">
              <Text fontSize={2} style={cellStyle}>
                {formatInTimeZone(date, timeZone, 'h:mm a')}
              </Text>
            </Box>
            <Box py={2} alignSelf="center">
              <Text fontSize={2} style={cellStyle}>
                {formatInTimeZone(date, timeZone, 'MMM d, yyyy')}
              </Text>
            </Box>
          </React.Fragment>
        ))}
      </Box>
    </Box>
  )
}
